import type { ReactNode } from 'react';

/**
 * Page container: max-width 1200px, generous gutters. Borrowed from Vercel's
 * intentional restraint — never stretch beyond 1200 on marketing pages.
 */
export default function Container({
  children,
  className = '',
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={`mx-auto w-full max-w-[1200px] px-6 lg:px-8 ${className}`}>{children}</div>
  );
}
